import { motion } from "framer-motion";
import { content } from "../../data/content";
import { Reveal } from "./Reveal";

export function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative w-full bg-cream px-5 md:px-10 py-24 md:py-36"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-14 md:mb-24">
          <Reveal>
            <p className="font-accent text-3xl md:text-5xl text-rose mb-2 -rotate-2">
              Pequeña lista importante
            </p>
            <h2 className="font-heading font-black uppercase tracking-tighter text-4xl md:text-7xl leading-[0.95] text-ink">
              {content.manifestoTitle}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {content.manifesto.map((item, i) => {
            const spans = [
              "md:col-span-7",
              "md:col-span-5 md:mt-16",
              "md:col-span-8 md:col-start-4",
            ];
            const rotate = ["-1deg", "1.5deg", "-1.2deg"];
            return (
              <Reveal
                key={item.n}
                delay={i * 0.08}
                className={spans[i % 3]}
              >
                <motion.div
                  whileHover={{ rotate: 0, y: -6 }}
                  style={{ rotate: rotate[i % 3] }}
                  transition={{ type: "spring", stiffness: 200, damping: 15 }}
                  className={`${item.color} rounded-2xl border-[3px] border-ink shadow-brutal-lg p-7 md:p-10`}
                >
                  <span className="font-accent text-6xl md:text-8xl leading-none block mb-3">
                    {item.n}
                  </span>
                  <h3 className="font-heading font-extrabold text-2xl md:text-4xl mb-3 tracking-tight">
                    {item.title}
                  </h3>
                  <p className="font-body font-medium text-base md:text-xl leading-relaxed">
                    {item.body}
                  </p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
